import React, { useEffect, useState, useMemo } from "react";
import Header from "./Header";
import Loader from "./Loader.js";
import "./Css/Onboading.css";
import EmployeeImg from "../assets/storeNew1.png";
import FilterIcon from "../assets/filterIcon.png";
import Search2 from "../assets/search.png";
import { IoClose } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import Editred from "../assets/editred.svg";
import { FaPen, FaEye, FaDownload } from "react-icons/fa";
import GreyArrow from "../assets/greyLeftAr.png";
import { Modal, Button } from "react-bootstrap";
import installIcon from "../assets/installIcon.svg";
import { AiOutlineEye } from "react-icons/ai";
import { Pagination } from "react-bootstrap";
import {
  Calendar,
  ChevronDown,
  Edit,
  Filter,
  Plus,
  Search,
} from "lucide-react";
import {
  server_post_data,
  get_all_resturant_onboarding,
  APL_LINK,
  new_restaurant_install,
  get_subscription_data,
} from "../ServiceConnection/serviceconnection.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  computeTodayDate,
  handleAphabetsChange,
  handleError,
  handleEmailChange,
  handleNumbersChange,
  handleIaphabetnumberChange,
  calculateMaxDate,
  computeplussevendays,
  handleSuccess,
  handleSuccessSession,
} from "../CommonJquery/CommonJquery.js";
import {
  ViewStaffPagesText,
  options_search,
  GuestManagementPageText,
} from "./../CommonJquery/WebsiteText";
import { storeData } from "../LocalConnection/LocalConnection.js";

// ---- moved outside the component so they aren't re-created on every render ----
const convertToDate = (dateString) => {
  if (!dateString) return new Date();
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
};

const formatDate = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatDateToDDMMYYYY = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const datePickerCustomStyles = {
  datePickerContainer: {
    position: "relative",
    width: "100%",
  },
  datePickerInput: {
    width: "100%",
    padding: "0.375rem 0.75rem",
    fontSize: "1rem",
    lineHeight: "1.5",
    color: "#495057",
    backgroundColor: "#fff",
    backgroundClip: "padding-box",
    border: "1px solid #ced4da",
    borderRadius: "0.25rem",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  },
};

const ENTRIES_PER_PAGE = 5;

function OnboadingSideTab() {
  const navigate = useNavigate();
  let flag = "1";

  const [startDate, setStartDate] = useState(
    convertToDate(computeplussevendays()),
  );
  const [endDate, setEndDate] = useState(convertToDate(computeTodayDate()));
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [selectedValue2, setSelectedValue2] = useState("0");
  const [editStaffData, seteditStaffData] = useState([]);
  const [filteredData, setfilteredData] = useState([]);
  const [StaffImageLinkData, setsStaffImageLinkData] = useState("");
  const [StaffImageMenuLinkData, setsStaffImageMenuLinkData] = useState("");
  const [selectedValue, setSelectedValue] = useState("Name");
  const [searchfilter, setSearchFilter] = useState("");
  const [SelectedData, setSelectedData] = useState([]);
  const [SelectedData1, setSelectedData1] = useState([]);
  const [subsdata, setSubsData] = useState([]);
  const [ProductOptions, setProductOptions] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [restaurantid, setrestaurantid] = useState("");
  const [subsDay, setsubsDay] = useState("");
  const [selectedOption, setSelectedOption] = useState("All");
  const [searchText, setSearchText] = useState("");
  const [filterOption, setFilterOption] = useState("");

  useEffect(() => {
    let call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  }, []);

  useEffect(() => {
    if (subsDay !== "") {
      const currentDate = new Date();
      if (!isNaN(currentDate.getTime())) {
        currentDate.setDate(currentDate.getDate() + parseInt(subsDay, 10));
        const updatedDate = currentDate.toISOString().split("T")[0];
        setSelectedDate(updatedDate);
      }
    }
  }, [subsDay]);

  const [showModal, setShowModal] = useState(false);
  const openModal = (guestData) => {
    setrestaurantid(guestData.primary_id);
    get_subscription_data_api(guestData.primary_id);
    setSelectedData1(guestData);
    setSubsData(guestData);
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    await server_post_data(get_all_resturant_onboarding, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          Response.data.message.data_restaurant.forEach((subObj) => {
            subObj.activedata =
              subObj.active_status === 1 ? "Active" : "Deactive";
          });
          seteditStaffData(Response.data.message.data_restaurant);
          setfilteredData(Response.data.message.data_restaurant);
          setProductOptions(Response.data.message.data_restaurant_options);
          setsStaffImageLinkData(
            APL_LINK + Response.data.message.data_restaurant_image,
          );
          setsStaffImageMenuLinkData(
            APL_LINK + Response.data.message.data_restaurant_menu_image,
          );
        }
        setshowLoaderAdmin(false);
      })
      .catch(() => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const get_subscription_data_api = async (call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", call_id);
    await server_post_data(get_subscription_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setSubsData(Response.data.message);
        }
        setshowLoaderAdmin(false);
      })
      .catch(() => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const InstallRestaurant = async (call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", call_id);
    await server_post_data(new_restaurant_install, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
          setshowLoaderAdmin(false);
        } else {
          closeModal();
          setshowLoaderAdmin(false);
          handleSuccessSession(Response.data.message, "/View_Restaurants");
          master_data_get("", "", "1", "0");
        }
      })
      .catch(() => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSelect = (event) => {
    setSelectedValue(event.target.value);
  };

  const search_data = () => {
    master_data_get(formatDate(startDate), formatDate(endDate), "2", "0");
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;
    setSearchFilter(searchValue);

    const filteredDatashow = editStaffData.filter((row) => {
      return Object.values(row).some((value) => {
        if (value !== null && value !== undefined) {
          return (
            typeof value === "string"
              ? value.toLowerCase()
              : value.toString().toLowerCase()
          ).includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setfilteredData(filteredDatashow);
  };

  const handleEdit = (option) => {
    navigate("/Edit_restaurant_new/" + option.primary_id);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [completeddata, setcompleteddata] = useState([]);

  const handleShowEyemodal = (data) => {
    setcompleteddata(data);
    setModalVisible(!modalVisible);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  const today = new Date();

  // ---- download the restaurant menu image ----
  const handleDownloadMenu = (menuFileName) => {
    if (!menuFileName || !StaffImageMenuLinkData) {
      handleError("Menu not available");
      return;
    }
    const fileUrl = StaffImageMenuLinkData + menuFileName;
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = menuFileName;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ---- pagination (memoized so it doesn't recompute on unrelated renders) ----
  const totalPages = useMemo(
    () => Math.ceil((filteredData?.length || 0) / ENTRIES_PER_PAGE),
    [filteredData],
  );

  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const currentData = useMemo(
    () =>
      filteredData?.slice(
        (currentPage - 1) * ENTRIES_PER_PAGE,
        currentPage * ENTRIES_PER_PAGE,
      ) || [],
    [filteredData, currentPage],
  );

  return (
    <div className="reservationHistory">
      {showLoaderAdmin && <Loader />}
      <Header />
      <div className="pageCntn_head">
        <div className="pageNameDiv">
          <p>Onboarding Management</p>
          <img src={GreyArrow} alt="Uprestro Dashboard" />
        </div>
        <Link to="/add_restaurant_new">
          <button
            data-bs-toggle="tooltip"
            data-bs-placement="left"
            title="Add Restaurant"
            className="createDiningArea createRestaurant Add_Restaurant"
          >
            Add Restraurant
          </button>
        </Link>
      </div>
      <div className="page_body">
        <div className="viewStaff_head">
          <div className="crm-filters-section">
            <div className="crm-filter-group filter_section">
              <label>Filter</label>
              <div className="date-input">
                <select
                  value={filterOption}
                  onChange={(e) => setFilterOption(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "0.5rem",
                    borderRadius: "4px",
                  }}
                  className="form-select"
                >
                  <option value="" disabled>
                    Select Option
                  </option>
                  <option value="today">Today</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                  <option value="this_year">This Year</option>
                  <option value="custom">Custom</option>
                </select>
              </div>
            </div>
            {filterOption === "custom" && (
              <>
                <div className="crm-filter-group">
                  <label className="">
                    {GuestManagementPageText.Start_Date}
                  </label>
                  <div className="crm-date-input">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      maxDate={today}
                      dateFormat="yyyy-MM-dd"
                      placeholderText={GuestManagementPageText.D_O_B}
                      style={datePickerCustomStyles.datePickerInput}
                      className="crm-form-control"
                    />
                    <Calendar className="crm-date-icon" size={16} />
                  </div>
                </div>
                <div className="crm-form-group1">
                  <label className="mb-2">End Date</label>
                  <div className="crm-date-input">
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      maxDate={today}
                      className="crm-form-control"
                      dateFormat="yyyy-MM-dd"
                      placeholderText={GuestManagementPageText.D_O_B}
                      style={datePickerCustomStyles.datePickerInput}
                    />
                    <Calendar className="crm-date-icon" size={16} />
                  </div>
                </div>
              </>
            )}
            <div className="crm-search-group">
              <div className="crm-search-input-container">
                <Search size={16} className="crm-search-icon" />
                <input
                  type="text"
                  placeholder="Search"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  className="crm-search-input"
                />
              </div>
            </div>

            <div className="d-flex gap-2 align-items-end">
              <button className="crm-search-btn" onClick={() => search_data()}>
                {GuestManagementPageText.Search_text}
              </button>
            </div>
          </div>
        </div>
        <div className="viewGuest_table ">
          <div className="viewGuest_table_container ">
            <div className="row m-0">
              <div className="col-md-12 table-responsive stickyTableheigh335">
                <table className="table">
                  <thead className="stickyHeaderClss">
                    <tr>
                      <th
                        scope="col"
                        style={{
                          color: "black",
                          fontSize: "15px",
                          fontWeight: "500",
                          whiteSpace: "nowrap",
                        }}
                        className="mx-3"
                      >
                        Sr.No
                      </th>
                      <th
                        scope="col"
                        style={{
                          color: "black",
                          fontSize: "15px",
                          fontWeight: "500",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Restaurant Details
                      </th>
                      <th
                        scope="col"
                        style={{
                          color: "black",
                          fontSize: "15px",
                          fontWeight: "500",
                          paddingRight: "1rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Contact Details
                      </th>
                      <th
                        scope="col"
                        style={{
                          color: "black",
                          fontSize: "15px",
                          fontWeight: "500",
                          paddingLeft: "0.3rem",
                        }}
                      >
                        Email
                      </th>
                      <th
                        scope="col"
                        style={{
                          color: "black",
                          fontSize: "15px",
                          fontWeight: "500",
                          paddingLeft: "0.5rem",
                          paddingRight: "1rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Entry Date
                      </th>
                      <th
                        scope="col"
                        style={{
                          color: "black",
                          fontSize: "15px",
                          fontWeight: "500",
                          paddingLeft: "0.5rem",
                          paddingRight: "1rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Subscription Date
                      </th>
                      <th
                        scope="col"
                        style={{
                          color: "black",
                          fontSize: "15px",
                          fontWeight: "500",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Onboarding Steps
                      </th>
                      <th
                        scope="col"
                        style={{
                          color: "black",
                          fontSize: "15px",
                          fontWeight: "500",
                          textAlign: "center",
                          paddingLeft: "2rem",
                          paddingRight: "4rem",
                        }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.map((option, index) => (
                      <React.Fragment key={option.primary_id ?? index}>
                        <tr className="tableRow tbodyStyle">
                          <td>
                            <div className="mx-3">
                              {(currentPage - 1) * ENTRIES_PER_PAGE + index + 1}
                            </div>
                          </td>
                          <td className="th1">
                            <div className="rsvnDetails saparator1">
                              <div className="rsvnDetailsImg">
                                <img
                                  src={
                                    StaffImageLinkData + option.restaurant_image
                                  }
                                  onError={(e) => (e.target.src = EmployeeImg)}
                                  alt="Uprestro Dashboard"
                                />
                              </div>
                              <div className="rsvnDetailsText">
                                <h6>{option.restaurant_name}</h6>
                                <p>{option.restaurant_tagline}</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="rsvnDetails">
                              <div className="rsvnContactDetails">
                                <p>{option.restaurant_mobile_no}</p>
                                {option.restaurant_other_no &&
                                  option.restaurant_other_no.length > 2 && (
                                    <p>{option.restaurant_other_no}</p>
                                  )}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="rsvnDetails">
                              <div className="rsvnContactDetails">
                                <p>{option.restaurant_email}</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="rsvnDetails">
                              <div className="rsvnContactDetails">
                                <p>{formatDateToDDMMYYYY(option.entry_date)}</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="rsvnDetails">
                              <div className="rsvnContactDetails">
                                <p>
                                  {formatDateToDDMMYYYY(
                                    option.subscription_start_date,
                                  )}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="rsvnDetails">
                              <div className="rsvnContactDetails Actionbttns">
                                {option.restaurant_step_save === 7 ? (
                                  option.restaurant_launch_status === 0 &&
                                  option.payment_status == 1 ? (
                                    <button
                                      className="insllt"
                                      onClick={() =>
                                        InstallRestaurant(option.primary_id)
                                      }
                                    >
                                      <img
                                        src={installIcon}
                                        alt="Install"
                                        title="Install"
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                        }}
                                      ></img>
                                    </button>
                                  ) : option.payment_status == 0 ? (
                                    "Payment Pending"
                                  ) : (
                                    "Completed"
                                  )
                                ) : (
                                  <p>Step {option.restaurant_step_save}</p>
                                )}
                              </div>
                            </div>
                          </td>

                          <td className="th2 tabledata">
                            <div className="actionsAlign d-flex justify-content-center marginClssOnbo gap-2">
                              {option.restaurant_step_save === 7 ? (
                                <AiOutlineEye
                                  onClick={() => handleShowEyemodal(option)}
                                  style={{
                                    cursor: "pointer",
                                    width: "20px",
                                    height: "20px",
                                  }}
                                  title="View Details"
                                />
                              ) : (
                                <button
                                  type="button"
                                  onClick={() => handleEdit(option)}
                                  className="closeModalStep"
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: "0",
                                  }}
                                >
                                  <FaPen
                                    size={15}
                                    color="var(--primary-color)"
                                    title="Edit"
                                  />
                                </button>
                              )}
                              {option.menu_image && (
                                <FaDownload
                                  onClick={() =>
                                    handleDownloadMenu(option.menu_image)
                                  }
                                  style={{
                                    cursor: "pointer",
                                    width: "16px",
                                    height: "16px",
                                  }}
                                  title="Download Menu"
                                />
                              )}
                            </div>
                          </td>
                        </tr>
                        <tr style={{ height: "1rem" }}></tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="pagination-container">
                <Pagination>
                  <Pagination.First
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />
                  {[...Array(totalPages)].map((_, index) => (
                    <Pagination.Item
                      key={index + 1}
                      active={index + 1 === currentPage}
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={closeModal} centered backdrop="static">
        <Modal.Body className="modal_body justify-content-start">
          <div className="success_img bodyText">
            <div className="row m-0">
              <div className="col-5">
                <p style={{ fontWeight: "400", letterSpacing: "0" }}>
                  {"Name :"}
                </p>
              </div>
              <div className="col-7">
                <p>{subsdata.restaurant_name}</p>
              </div>
            </div>
            <div className="row m-0">
              <div className="col-5">
                <p style={{ fontWeight: "400", letterSpacing: "0" }}>
                  {"Transaction Id :"}
                </p>
              </div>
              <div className="col-7">
                <p>{subsdata.transaction_id}</p>
              </div>
            </div>
            <div className="row m-0">
              <div className="col-5">
                <p style={{ fontWeight: "400", letterSpacing: "0" }}>
                  {"Subscription Amount :"}
                </p>
              </div>
              <div className="col-7">
                <p>{subsdata.subscription_amount}</p>
              </div>
            </div>
            <div className="row m-0">
              <div className="col-5">
                <p style={{ fontWeight: "400", letterSpacing: "0" }}>
                  {"Subscription Date:"}
                </p>
              </div>
              <div className="col-7">
                <p>{subsdata.subscription_start_date}</p>
              </div>
            </div>

            <form id="AddSubsData">
              <div className="form-group">
                <label
                  style={{ fontWeight: "500" }}
                  htmlFor="subscription_period"
                >
                  Subscription Period (In Day's)
                </label>
                <input
                  style={{ marginBottom: "0.5rem" }}
                  type="text"
                  onInput={handleNumbersChange}
                  className="form-control"
                  id="subscription_period"
                  name="subscription_period"
                  defaultValue={subsDay}
                  onChange={(e) => setsubsDay(e.target.value)}
                  placeholder="No of Days"
                  maxLength={4}
                />
              </div>
              <div className="form-group">
                <label
                  style={{ fontWeight: "500" }}
                  htmlFor="subscription_period"
                >
                  Subscription End Date
                </label>
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  className=" trio_mandatory form-control  input_field_custom1  "
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Select a date"
                />
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="logoutNoBtn hoverRed" onClick={closeModal}>
            Close
          </Button>
          <Button
            className=" hoverRed"
            onClick={() => InstallRestaurant(subsdata.primary_id)}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modalVisible}
        onHide={handleCloseModal}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="headingMidlTitle">Description</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="eyebtnContn">
            <div className="row">
              <div className="col-md-6 p-0">
                <div className="leftDataStepp">
                  <p>Restaurant Name :</p>
                  <p>Restaurant TagLine :</p>
                  <p>Restaurant About :</p>
                  <p>Restaurant Email :</p>
                  <p>Restaurant Mobile :</p>
                  <p>Fssai Number :</p>
                  <p>GSTIN Number :</p>
                  <p>Restaurant City :</p>
                  <p>Restaurant State :</p>
                  <p>Restaurant Country :</p>
                  <p>Restaurant Menu :</p>
                </div>
              </div>
              <div className="col-md-6 p-0">
                <div className="rightDataStpp">
                  <p>{completeddata.restaurant_name || "not found"}</p>
                  <p>{completeddata.restaurant_tagline}</p>
                  <p>{completeddata.restaurant_about}</p>
                  <p>{completeddata.restaurant_email}</p>
                  <p>{completeddata.restaurant_mobile_no}</p>
                  <p>{completeddata.restaurant_fssai}</p>
                  <p>{completeddata.restaurant_gstin}</p>
                  <p>{completeddata.restaurant_city}</p>
                  <p>{completeddata.restaurant_state}</p>
                  <p>{completeddata.restaurant_country}</p>
                  <p>
                    {completeddata.menu_image ? (
                      <button
                        type="button"
                        className="btn btn-sm hoverRed"
                        onClick={() =>
                          handleDownloadMenu(completeddata.menu_image)
                        }
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <FaDownload size={13} /> Download Menu
                      </button>
                    ) : (
                      "Not uploaded"
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default OnboadingSideTab;
